export interface Person {
  id: string
  email: string
  fullName: string
  startDate: string
  endDate?: string | null
  bambooId: string
  team: string
}

export type PersonCreateDto = Omit<Person, 'id'>

export const VALID_TEAMS = ['Dev', 'Bi', 'Analyst'] as const
export type Team = (typeof VALID_TEAMS)[number]
